module.exports = {
  NEVER: 'No tool approval',
  ALWAYS: 'Require tool approval',
  AUTOMATIC: 'Automatic tool approval',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  JWT: 'JWT',
  MONGODB: 'Mongo DB',
  MCP_SSE: 'MCP SSE',
  MCP_HTTP: 'MCP HTTP',
  MCP_STDIO: 'MCP STDIO',
  MCP_OPENAI_CONNECTOR: 'MCP OpenAI Connector',
  MCP_BOTH: 'HTTP / SSE',
  MCP_ONLY_STDIO: 'STDIO',
  JDBC: 'JDBC',
  SMTP: 'SMTP',
  TWILIO: 'Twilio',
  OAUTH: 'OAuth',
  OAUTH2_REFRESH_TOKEN: 'OAuth',
  SLACK: 'Slack',
  DELETE: 'Delete',
  GET: 'Get',
  PATCH: 'Patch',
  POST: 'Post',
  PUT: 'Put',
  SUCCESSFUL: 'Successful',
  UNSUCCESSFUL: 'Unsuccessful',
  FAILED: 'Failed',
  IN_PROGRESS: 'In progress',
  NEW: 'New',
  ON_HOLD: 'On hold',
  CRON: 'Cron',
  REST: 'Rest',
  RUN_PROCESS: 'Run process',
  RERUN_EVENT: 'Rerun event',
  VALIDATION_FAILED: 'Validation Failed',
  EMAIL: 'Smtp',
  EXECUTE_PROCESS: 'Execute process',
  EXECUTE_PARALLEL_STEPS: 'Execute Parallel Step',
  FOREACH: 'For Each',
  GROOVY: 'Groovy',
  JS: 'JavaScript',
  KOTLIN: 'Kotlin',
  SWITCH: 'Switch',
  WHILE: 'While',
  DO_WHILE: 'Do While',
  IF: 'If',
  EDIT: 'Edit',
  VIEW: 'View',
  USE: 'Use',
  PROCESS_INACTIVE: 'Process Inactive',
  FRONTEND: 'Frontend',
  INSTANCE: 'Instance',
  PASTE: 'Paste from memory',
  CREATE: 'Create',
  COUNTER: 'Counter',
  WAIT: 'Wait',
  FLOWY_CACHE: 'Flowy Cache',
  YES: 'Yes',
  NO: 'No',
  PICTURE: 'Picture',
  FONT: 'Font',
  GLOBAL_TRANSLATION: 'Translation',
  MODULE: 'Module',
  PROCESS: 'Process',
  PROCESS_CREDENTIAL: 'Credential',
  SETTING: 'Setting',
  TEXT_TEMPLATE: 'Text Template',
  TEMPLATE: 'Template',
  TRIGGER_CRON: 'Trigger Cron',
  TRIGGER_REST: 'Trigger Rest',
  TRIGGER_MCP: 'Trigger MCP',
  STATIC_RESOURCE: 'Static Resource',
  NUMBER: 'Number',
  STRING: 'String',
  MAX_LENGTH: 'Max Length',
  MAX_VALUE: 'Max Value',
  MIN_LENGTH: 'Min Length',
  MIN_VALUE: 'Min Value',
  BODY: 'Body',
  HEADERS: 'Headers',
  QUERY_PARAMS: 'Query Params',
  VALIDATION_RULE: 'Validation Rule',
  FLOWY: 'Flowy',
  BOOLEAN: 'Boolean',
  TIMESTAMP: 'Timestamp',
  INTEGER: 'Integer',
  FLOAT: 'Float',
  PROCESS_SETTING: 'Process Settings',
  CHECK_EMAIL_AVAILABILITY: 'Check Email Availability',
  CREATE_USER: 'Create User',
  GENERATE_API_KEY: 'Generate API Key',
  VALIDATE_API_KEY: 'Validate API Key',
  USER: 'User',
  FILE_JSON: 'File JSON',
  FILE_XML: 'File XML',
  PLUGIN: 'Plugin',
  AWS: 'AWS',
  S3: 'S3',
  LIST: 'List',
  READ: 'Read',
  UNSET_VARIABLES: 'Unset Variables',
  SECURITY: 'Security',
  DECRYPT: 'Decrypt',
  ENCRYPT: 'Encrypt',
  HANDLEBARS: 'Handlebars',
  MUSTACHE: 'Mustache',
  THYMELEAF: 'Thymeleaf',
  VELOCITY: 'Velocity',
  SCRIPT: 'Script',
  IMAP: 'Imap',
  TIMEOUT: 'Timeout',
  MARK_READ: 'Mark Read',
  MARK_UNREAD: 'Mark Unread',
  SEARCH: 'Search',
  CUSTOM: 'Custom',
  PATH_VARIABLES: 'Path variables',
  PDF: 'PDF',
  LATEX: 'LaTeX',
  FINISHED: 'Finished',
  CLEAN_UP: 'Clean Up',
  FIX_EXECUTION_STATE: 'Fix Execution State',
  MAX_SIZE: 'Max Size in bytes',
  PROCESS_EVENTS: 'Process events',
  ARRAY: 'Array',
  DOUBLE: 'Double',
  MIN_SIZE: 'Min size in bytes',
  MAX_SIZE_ARRAY: 'Max. amount of records',
  MIN_SIZE_ARRAY: 'Min. amount of records',
  VALIDATE_PASSWORD: 'Validate password',
  GET_USER_DETAILS: 'Get user details',
  GET_USER_ROLES: 'Get user roles',
  CREDENTIALS_SYNC: 'Credentials sync',
  CONNECTIONS_SYNC: 'Connections sync',
  CRON_TRIGGERS_SYNC: 'Cron triggers sync',
  INSTANCE_HEARTBEAT: 'Instance heartbeat',
  PLUGINS_SYNC: 'Plugins sync',
  REST_TRIGGER_SYNC: 'Rest trigger sync',
  SETTINGS_SYNC: 'Settings sync',
  VALIDATION: 'Validation Rule',
  OBJECT: 'Object',
  LONG: 'Long',
  ATTACHMENTS: 'Get attachments',
  CSV: 'CSV file',
  CSV_TO_JSON: 'CSV to JSON',
  JSON_TO_CSV: 'JSON to CSV',
  CONVERT: 'Convert',
  DOWNLOAD: 'Download',
  INFO: 'Info',
  RESCALE: 'Rescale',
  IMAGE: 'Image',
  FROM_TEMPLATE: 'From template',
  EXECUTE_EXTERNAL_COMMAND: 'Execute external command',
  TRY_CATCH: 'Try Catch',
  UNTIL: 'Until',
  DO_UNTIL: 'Do Until',
  KAFKA: 'Kafka',
  MESSAGING: 'Messaging',
  TRIGGER_MESSAGING: 'Trigger Messaging',
  INSTANCE_ADMIN: 'Instance Admin',
  INSTANCE_PROCESSING: 'Instance Processing',
  PROCESSING: 'Processing',
  ADMIN: 'Admin',
  PAYMENT_SENSE: 'Payment Sense',
  PAYMENT_SENSE_PAC: 'Paymentsense PAC',
  CANCEL_TRANSACTION: 'Cancel Transaction',
  GET_REPORT: 'Get Report',
  GET_TERMINAL: 'Get Terminal',
  GET_TERMINALS: 'Get Terminals',
  GET_TRANSACTION: 'Get Transaction',
  SIGNATURE: 'Signature',
  START_REPORT: 'Start Report',
  START_TRANSACTION: 'Start Transaction',
  BANKING: 'Banking',
  END_OF_DAY: 'End of Day',
  X_BALANCE: 'X Balance',
  Z_BALANCE: 'Z Balance',
  ACCOUNT_VERIFICATION: 'Account Verification',
  COMPLETION: 'Completion',
  DUPLICATE: 'Duplicate',
  PRE_AUTH: 'Pre Auth',
  REFUND: 'Refund',
  SALE: 'Sale',
  JMS: 'JMS',
  CLEAN_CAPTCHA: 'Clean captcha',
  MESSAGING_TRIGGER_SYNC: 'Messaging trigger sync',
  PAYMENT_SENSE_CONNECT_E: 'Paymentsense Connect E',
  ACCESS_TOKEN: 'Access Token',
  CROSS_REFERENCE_PAYMENT: 'Cross Reference Payment',
  PAYMENT_DETAILS: 'Payment Details',
  PAYMENT_METHODS: 'Payment Methods',
  RESUME_PAYMENT: 'Resume Payment',
  REVOKE_ACCESS_TOKEN: 'Revoke Access Token',
  GET_USERS_BY_ROLES: 'Get users by roles',
  UUID: 'UUID',
  CREDENTIAL: 'Credential',
  UPDATE: 'Update',
  ENABLE: 'Enable',
  DISABLE: 'Disable',
  QUERY_BUILDER: 'Query Builder',
  REGEX: 'Regex',
  RABBITMQ: 'RabbitMQ',
  AWS_SQS: 'AWS SQS',
  ZIP: 'Zip',
  COMPRESS: 'Compress',
  DECOMPRESS: 'Decompress',
  CLEAN_UP_ERRORS: 'Clean up errors',
  CLEAN_HISTORY: 'Clean history',
  LOG: 'Log',
  ROLE: 'Permission: set roles',
  ROLES: 'Roles',
  ENCODER: 'Encoder',
  ENCODE_HTML_SPECIAL_CHARS: 'Encode HTML special chars',
  URL_DECODE: 'URL decode',
  URL_ENCODE: 'URL encode',
  BASE64_ENCODE: 'Base64 encode',
  BASE64_DECODE: 'Base64 decode',
  LIBRARY: 'Library',
  LIBRARIES: 'Libraries',
  ASYNC: 'Asynchronous',
  SYNC: 'Synchronous',
  INLINE: 'Inline',
  EMBEDDED: 'Embedded',
  STORAGE: 'Storage',
  UPSERT: 'Upsert',
  CLEAN_STORAGE: 'Storage Clean Up',
  CAUGHT: 'Caught',
  FORMATTING: 'Formatting',
  DECIMAL_FORMAT: 'Decimal Format',
  PYTHON: 'Python',
  XSLT: 'XSLT',
  LIBRARIES_SYNC: 'Libraries sync',
  ADD: 'Add (will add additional values to the existing ones)',
  REMOVE: 'Remove (will remove values from the existing ones if they exist)',
  REPLACE: 'Replace (will replace existing values with the new ones)',
  CLEAN_REST_TEMPLATES: 'Clean rest templates',
  TRY: 'Try',
  CATCH: 'Catch',
  FINALLY: 'Finally',
  EXCEPTION: 'Exception',
  CLEAN_GROOVY_SCRIPTS: 'Clean groovy scripts',
  QUERY: 'Query',
  BATCH: 'Batch',
  FETCHED: 'Fetched',
  MQTT: 'MQTT',
  MARKDOWN: 'Markdown',
  GRAPHQL: 'GraphQL',
  RSS: 'RSS',
  ALL: 'All',
  EVENT_HANDLER: 'Event Handler',
  TRIGGER_EVENT_HANDLER: 'Trigger Event Handler',
  TRIGGER_UI: 'Trigger UI',
  EVENT_HANDLER_TRIGGERS_SYNC: 'Event Handler triggers sync',
  VARCHAR: 'Varchar',
  BIGINT: 'Bigint',
  OPTIONAL: 'Optional',
  REQUIRED: 'Required',
  ONE_TO_ONE: 'One to one',
  ONE_TO_MANY: 'One to many',
  MANY_TO_ONE: 'Many to one',
  MANY_TO_MANY: 'Many to many',
  ENTITY: 'Entity',
  FIND_BY_ID: 'Find by id',
  HANDLE_EVENTS: 'Handle Events',
  VALIDATION_BODY: 'Validation Body',
  VALIDATION_ID: 'Validation Id',
  JSON: 'JSON',
  CHANGE_ENCODING: 'Change encoding',
  REMOVE_HTML_TAGS: 'Remove HTML tags',
  EXACT: 'Exact',
  BEGINNING: 'Beginning',
  START: 'Start',
  END: 'End',
  EVERYWHERE: 'Everywhere',
  ESC_CHARS: 'ESC/POS converter',
  VALIDATION_PATH: 'Validation Path',
  NONE: 'None',
  WEB_SEARCH: 'Web search',
  SHELL: 'Shell',
  WEB_FETCH: 'Web fetch',
  CODE_EXECUTION: 'Code execution',
  ADVISOR: 'Advisor',
  BASIC: 'Basic',
  BEARER: 'Bearer',
  REST_BASIC: 'Rest Basic',
  REST_BEARER: 'Rest Bearer',
  SOAP: 'SOAP',
  FTP: 'FTP',
  specialFtpSftp: 'FTP / SFTP',
  UPLOAD: 'Upload',
  BETWEEN: 'Between',
  SFTP: 'SFTP',
  all: 'All',
  onlyExists: 'Only exists',
  onlyNotExists: 'Only not found',
  onlyMissing: 'Only with missing resources ',
  onlyNotMissing: 'No missing resources',
  onlyConflicts: 'Only with conflicts',
  onlyNotConflicts: 'Not conflicts',
  XML: 'XML',
  JSON_TO_XML: 'JSON to XML',
  XML_TO_JSON: 'XML to JSON',
  INTERRUPT_REQUEST: 'Interrupt Request',
  INTERRUPT_ACKNOWLEDGED: 'Interrupt Acknowledged',
  OCR: 'OCR',
  QR: 'QR',
  OPEN_AI: 'Open AI',
  CHAT_GPT: 'Chat GPT',
  CLAUDE: 'Claude',
  DEEP_SEEK: 'Deep Seek',
  ANTHROPIC: 'Anthropic',
  JIRA: 'Jira',
  STRIPE_CONNECT: 'Stripe Connect',
  SYSTEM: 'System',
  ASSISTANT: 'Assistant',
  LDAP: 'LDAP',
  SSH: 'SSH',
  SSH_KEY: 'SSH Key',
  GIT: 'Git',
  BIND: 'Bind',
  MODIFY: 'Modify',
  XLS: 'XLS',
  YAML: 'YAML',
  JSON_TO_YAML: 'JSON to YAML',
  YAML_TO_JSON: 'YAML to JSON',
  EVALUATE: 'Evaluate',
  SORT: 'Sort',
  GROUP_BY: 'Group By',
  DIFF: 'Diff',
  FLATTEN: 'Flatten',
  UNFLATTEN: 'Unflatten',
  FILE_TO_JSON: 'File to JSON',
  FILE_TO_BASE64: 'File to Base64',
  BASE64_TO_FILE: 'Base64 to File',
  FILE_TO_STRING: 'File to String',
  XLS_TO_JSON: 'XLS to JSON',
  JSON_TO_XLS: 'JSON to XLS',
  LOW: 'Low',
  MEDIUM: 'Medium',
  QUARTILE: 'Quartile',
  HIGH: 'High',
  I_CALENDAR: 'iCalendar',
  OUTLOOK_CALENDAR: 'Outlook Calendar',
  MS_GRAPH_API: 'Microsoft Graph',
  CLOUD_FRONT: 'CloudFront',
  AUTH: 'Auth',
  MAKE_DIRECTORY: 'Make Directory',
  RENAME: 'Rename',
  GENERATE: 'Generate',
  DECODE: 'Decode',
  GET_PAGE_COUNT: 'Get Page Count',
  GET_PAGE_AS_PICTURE: 'Get Page As Picture',
  MERGE: 'Merge',
  GET_TEXT: 'Get Text',
  TIMER: 'Timer',
  CROP: 'Crop',
  SET_VARIABLES: 'Set Variables',
  PROCESS_ASYNC: 'Process Async',
  PROCESS_SYNC: 'Process Sync',
  PROCESS_INLINE: 'Process Inline',
  PROCESS_EMBEDDED: 'Process Embedded',
  INSTANCE_SYSTEM_STATISTIC: 'Instance System Statistic',
  CLEAN_EDIT_SESSION: 'Clean Edit Session',
  CLEAN_CACHE_FILES: 'Clean cache files',
  CLEAN_INSTANCES: 'Clean instances',
  CLEAN_OPERATION_LOG: 'Clean Operation Log',
  RECONCILE_APPLICATION_CONTAINERS: 'Reconcile Application Containers',
  LOGOUT_USERS: 'Logout Users',
  INCREMENT: 'Increment',
  DECREMENT: 'Decrement',
  types: {
    VALIDATION_RULE: "Validation Rule",
    PROCESS: "Process",
    ENTITY: "Entity",
    TRIGGER_REST: "REST Trigger"
  },
  CSS: 'Css',
  ALL_CACHE_TYPES: 'All cache types',
  HTML: 'HTML',
  TEXT: 'Text',
  MCP: 'MCP',
  GET_TOOLS: 'Get Tools',
  RUN_TOOL: 'Run Tool',
  GET_LIST_RESOURCES: 'Get List Resources',
  READ_RESOURCE: 'Read Resource',
  GET_LIST_PROMPTS: 'Get List Prompts',
  GET_PROMPT: 'Get Prompt',
  CREATE_ISSUE: 'Create Issue',
  UPDATE_ISSUE: 'Update Issue',
  GET_ISSUE: 'Get Issue',
  TRANSITION_ISSUE: 'Transition Issue',
  SEARCH_ISSUES: 'Search Issues',
  ADD_COMMENT: 'Add Comment',
  ATTACH_FILE: 'Attach File',
  ADD_WORKLOG: 'Add Worklog',
  TIME_TO_MINUTES: 'Time to Minutes',
  TIME_TO_SECONDS: 'Time to Seconds',
  MINUTES_TO_TIME: 'Minutes to Time',
  SECONDS_TO_TIME: 'Seconds to Time',
  TIME_DIFFERENCE: 'Time Difference',
  TIME_HANDLER: 'Time Handler',
  SECONDS: 'Seconds',
  MINUTES: 'Minutes',
  TIME: 'Time',
  GET_USER_INFO: 'Get User Info',
  ADD_USER: 'Add User',
  DOWN: 'Down',
  UP: 'Up',
  ON_BLUR: 'On Blur',
  ON_CHANGE: 'On Change',
  ON_CLICK: 'On Click',
  ON_HOVER: 'On Hover',
  ON_KEY_DOWN: 'On Key Down',
  ON_LOAD: 'On Load',
  ON_SCROLL: 'On Scroll',
  ON_UNLOAD: 'On Unload',
  SMART: 'Smart',
  TAGS: 'Tags',
  TAG: 'Tag',
  RETRIEVE_BALANCE: 'Retrieve Balance',
  RETRIEVE_BALANCE_TRANSACTION: 'Retrieve Balance Transaction',
  LIST_BALANCE_TRANSACTIONS: 'List Balance Transactions',
  CREATE_PAYMENT_INTENT: 'Create Payment Intent',
  UPDATE_PAYMENT_INTENT: 'Update Payment Intent',
  RETRIEVE_PAYMENT_INTENT: 'Retrieve Payment Intent',
  CONFIRM_PAYMENT_INTENT: 'Confirm Payment Intent',
  CANCEL_PAYMENT_INTENT: 'Cancel Payment Intent',
  CREATE_CUSTOMER: 'Create Customer',
  RETRIEVE_CUSTOMER: 'Retrieve Customer',
  UPDATE_CUSTOMER: 'Update Customer',
  LIST_CUSTOMERS: 'List Customers',
  CREATE_CHARGE: 'Create Charge',
  RETRIEVE_CHARGE: 'Retrieve Charge',
  LIST_CHARGES: 'List Charges',
  CREATE_REFUND: 'Create Refund',
  RETRIEVE_REFUND: 'Retrieve Refund',
  LIST_REFUNDS: 'List Refunds',
  RETRIEVE_DISPUTE: 'Retrieve Dispute',
  LIST_DISPUTES: 'List Disputes',
  CLOSE_DISPUTE: 'Close Dispute',
  CREATE_PRODUCT: 'Create Product',
  UPDATE_PRODUCT: 'Update Product',
  RETRIEVE_PRODUCT: 'Retrieve Product',
  LIST_PRODUCTS: 'List Products',
  DELETE_PRODUCT: 'Delete Product',
  CREATE_PAYOUT: 'Create Payout',
  RETRIEVE_PAYOUT: 'Retrieve Payout',
  LIST_PAYOUTS: 'List Payouts',
  CANCEL_PAYOUT: 'Cancel Payout',
  POST_MESSAGE: 'Post Message',
  FETCH_MESSAGES: 'Fetch Messages',
  EXECUTE_AI_AGENT: 'AI Agent',
  AI_AGENT: 'AI Agent',
  SCREEN: 'Screen',
  FLOW: 'Flow',
  APPLICATION: 'Application',
  THROW_EXCEPTION: 'Throw Exception',
  WHATSAPP: 'WhatsApp',
  SEND_MESSAGE: 'Send Message',
  JSON_TO_TOON: 'JSON to Toon',
  XML_TO_TOON: 'XML to Toon',
  TOON_TO_JSON: 'Toon to JSON',
  TOON_TO_XML: 'Toon to XML',
  TOON: 'Toon',
  PEPPOL: 'PEPPOL',
  TIKA: 'Tika',
  EXTRACT_TEXT_AND_METADATA: 'Extract text and metadata',
  DETECT_DOCUMENT_TYPE: 'Detect document type',
  TRIGGER_WHATSAPP: 'Trigger WhatsApp',
  CREATE_INVOICE: 'Create Invoice',
  READ_INVOICE: 'Read Invoice',
  VALIDATE_INVOICE: 'Validate Invoice',
  STANDARD: 'Standard',
  CONTAINERIZED: 'Containerized',
  DOCKER: 'Docker',
  KUBERNETES: 'Kubernetes',
  CONTAINER_RUNNING: 'Running',
  CONTAINER_PAUSED: 'Paused',
  CONTAINER_STOPPED: 'Stopped',
  lifecycleBuildTriggering: 'Triggering Build...',
  lifecycleBuildPolling: 'Building...',
  lifecycleBuildComplete: 'Build Complete',
  lifecycleBuildFailed: 'Build Failed',
  lifecycleRunTriggering: 'Triggering Run...',
  lifecycleRunPolling: 'Running...',
  lifecycleRunComplete: 'Run Complete',
  lifecycleRunFailed: 'Run Failed',
  lifecycleStopTriggering: 'Triggering Stop...',
  lifecycleStopPolling: 'Stopping...',
  lifecycleStopComplete: 'Stop Complete',
  lifecycleStopFailed: 'Stop Failed',
  lifecycleBuildTriggeringText: 'Triggering build action...',
  lifecycleBuildPollingText: 'Build in progress...',
  lifecycleBuildCompleteText: 'Build completed successfully',
  lifecycleRunTriggeringText: 'Triggering run action...',
  lifecycleRunPollingText: 'Run in progress...',
  lifecycleRunCompleteText: 'Run completed successfully',
  lifecycleStopTriggeringText: 'Triggering stop action...',
  lifecycleStopPollingText: 'Stop in progress...',
  lifecycleStopCompleteText: 'Stop completed successfully',
  lifecycleBuildTriggered: 'Build triggered',
  lifecycleRunTriggered: 'Run triggered',
  TRANSACTION: 'Transaction',
  lifecycleStopTriggered: 'Stop triggered',
  lifecycleStatusFetching: 'Fetching Status...',
  lifecycleStatusComplete: 'Lifecycle Status',
  lifecycleStatusFailed: 'Status Fetch Failed',
  lifecycleStatusFetchingText: 'Fetching lifecycle status...',
  uploadTriggering: 'Triggering upload...',
  uploadPolling: 'Polling upload status...'
}
